import '../../../src/styles/globals.scss';
import React, {useEffect, useMemo, useState} from "react";
// @ts-ignore
import InputMask from 'react-input-mask';
/*import C2CService from '../../../services/c2c';*/
import {useForm} from "react-hook-form";
import PulPalLoader from "../PulPalLoader/PulPalLoader";
import {useSelector} from "react-redux";
import C2CService from "../../services/c2c";
import {NavLink, useParams} from "react-router-dom";
import {t} from "i18next";

export const Receipt = () => {
    const [loadingNotTransparent, setLoadingNotTransparent] = useState<boolean>(false);
    const [data, setData] = useState<any>();
    const [status, setStatus] = useState<any>();
    const {id} = useParams();

    useEffect(() => {

        const fetchData = async () => {
            if (!id) return;

            try {
                setLoadingNotTransparent(true);

                const res: any = await C2CService.c2cReceiptTransfer(id);
                setData(res.data);

                const isSuccess = res.data?.status === 0 && res.data?.rc === 0;
                setStatus(isSuccess);

                console.log(res.data, 'data');
            } catch (e) {
                console.error("API error:", e);
            } finally {
                setLoadingNotTransparent(false);
            }
        };

        fetchData();
    }, [id]);

    const maskCardNumber = (cardNumber: string): string => {
        if (!cardNumber || cardNumber.length !== 16) return cardNumber;
        return cardNumber.slice(0, 6) + '*'.repeat(6) + cardNumber.slice(12);
    };

    const formattedDate = useMemo(() => {
        if (!data?.createdAt) return '';

        const date = new Date(data.createdAt);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        return `${day}.${month}.${year} ${hour}:${minute}`;
    }, [data?.createdAt]);

    return (
        <div className="container">

            <div className="mt-5 pt-5">
                <div className="fw-bold fs-3">Köcürmə tamamlandı</div>
            </div>

            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="bg-white rounded-4 shadow-sm p-4 text-center position-relative">
                            <div className="custom-cut position-absolute top-0 start-0 w-100 h-100"></div>
                            <div
                                className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3 ${
                                     status && status === true ? 'bg-info' : 'bg-danger'
                                }`}
                                style={{width: '60px', height: '60px'}}
                            >

  <span className="fs-2 text-white">
    {status && status === true ? '✓' : '✕'}
  </span>
                            </div>

                            <h5 className="fw-bold mb-4">{status && status === true ? 'Əməliyyat uğurla həyata keçdi' : 'Əməliyyat tamamlanmadı'}</h5>

                            <div className="text-start">
                                <hr/>
                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Çekin nömrəsi:</div>
                                    <div className="col-6">{data?.orderId}</div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Tarix:</div>
                                    <div className="col-6">{formattedDate}</div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Xidmət:</div>
                                    <div className="col-6">Kartdan karta</div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Kartın nömrəsi:</div>
                                    <div className="col-6">{maskCardNumber(data?.beneficiarCard?.cardNumber)}</div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Qəbul edənin kart nömrəsi:</div>
                                    <div className="col-6">{maskCardNumber(data?.receiverCard)}</div>
                                </div>

                                {/* <div className="row mb-2">
                                    <div className="col-6 text-muted">Telefon:</div>
                                    <div className="col-6">{data?.orderId}</div>
                                </div>
*/}
                                <hr/>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Məbləğ:</div>
                                    <div className="col-6">{data?.amount} {data?.currency}</div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">{t('Commission')}:</div>
                                    <div className="col-6">{data?.fee} {data?.currency}</div>
                                </div>
                                {/*


                                 <div className="row mb-2">
                                    <div className="col-6 text-muted">Komissiya, AZN:</div>
                                    <div className="col-6">{data?.orderId}</div>
                                </div>
*/}

                            </div>

                            <div className="d-flex justify-content-center gap-3 mt-4">
                                <NavLink className="btn btn-outline-secondary px-4" to='/'>Ana səhifə</NavLink>
                                {/*<button className="btn btn-info text-white px-4">Qəbzi göndər</button>*/}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {loadingNotTransparent && (
                <div
                    className={`pulpal-loader-wrapper ${loadingNotTransparent ? 'pulpal-loader-wrapper--not-transparent' : ''} `}>
                    <PulPalLoader/>
                </div>
            )}
        </div>
    )
}
